import baseURL from "../config";
import {
    Box,
    Button,
    TextField,
    FormControl,
    InputLabel,
    NativeSelect,
    useTheme,
    Select,
    IconButton,
  MenuItem
  } from "@mui/material";
  import { Formik } from "formik";
  import * as yup from "yup";
  import useMediaQuery from "@mui/material/useMediaQuery";
  import Header from "../Components/Header";
  import { Link, useNavigate } from "react-router-dom";
  import axios from "axios";
  import { ToastContainer, toast } from "react-toastify";
  import "react-toastify/dist/ReactToastify.css";
  import { tokens } from "../theme";
  import KeyboardReturnOutlinedIcon from "@mui/icons-material/KeyboardReturnOutlined";
  import { useEffect, useState } from "react";
  import * as React from "react";
  
  const CustomerGForm = () => {
    const theme = useTheme();
    const isNonMobile = useMediaQuery("(min-width:600px)");
    const isTablet = useMediaQuery("(min-width:1175px");
    const colors = tokens(theme.palette.mode);
   const navigate = useNavigate();
    
   
    
    const [customerGroupData, setCustomerGroupData] = useState();
    
    


    const handleFormSubmit = async (values, actions) => {
      try {
           await axios.post(
            `${baseURL}/api/CustomerGroup/CreateCustomerGroup`,
            {
                customerGroupId: values.customerGroupId,
              name: values.name ,
              discountPercentage: values.discountPercentage ,
              limit: values.limit ,
            },    
          );
      navigate("/CustomerGroup");
    } catch (error) {

     if (error.response.data === "Customer Group me kete ID ekziston!")
        {
                toast.error("Customer Group me kete ID ekziston!");
        }
      if (error.response) {
        
        actions.resetForm();
        toast.error("Dicka shkoi keq! ");
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log("Error", error.message);
      }
    }
  };
  
    return (
      <Box m="20px">
        <ToastContainer hideProgressBar={true} autoClose={2000} />
        <Header title="Shto Customer Group" subtitle="Plotesoni te dhenat per Customer Group" />
        <Link to="/CustomerGroup" style={{ textDecoration: "none" }}>
          <Button
            variant="contained"
            sx={{ backgroundColor: colors.primary[700], marginBottom: 2 }}
          >
            <KeyboardReturnOutlinedIcon />
            Tabela Customer Group
          </Button>
        </Link>

        <Formik
          onSubmit={handleFormSubmit}
          initialValues={initialValues}
          validationSchema={checkoutSchema}
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
            setValues,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit}>
              <Box
                display="grid"
                gap="30px"
                gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                sx={{
                  "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                }}
              >
                  <TextField
                  fullWidth
                  variant="filled"
                  label="ID"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  name="customerGroupId"
                  value={values.customerGroupId}
                  error={!!touched.customerGroupId && !!errors.customerGroupId}
                  sx={{ gridColumn: "span 2" }}
                />
                 <TextField
                  fullWidth
                  variant="filled"
                  label="Name"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  name="name"
                  value={values.name}
                  error={!!touched.name && !!errors.name}
                  sx={{ gridColumn: "span 2" }}
                />
                    <TextField
                  fullWidth
                  variant="filled"
                  label="Limit"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  name="limit"
                  value={values.limit}
                  error={!!touched.limit && !!errors.limit}
                  sx={{ gridColumn: "span 2" }}
                />
                
            
                <TextField
                  fullWidth
                  variant="filled"
                  label="Discount Percentage (%)"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  name="discountPercentage"
                  value={values.discountPercentage}
                  error={!!touched.discountPercentage && !!errors.discountPercentage}
                  sx={{ gridColumn: "span 2" }}
                />
               
                <Box sx={{ gridColumn: "span 4" }}>
                  {" "}
                  <hr
                    style={{
                      border: "none",
                      height: "2px",
                      backgroundColor: "white",
                      margin: "0",
                      padding: "0",
                    }}
                  />
                </Box>   
              </Box>
              <Box display="flex" justifyContent="end" mt="20px">
                <Button type="submit" style={{ backgroundColor: colors.primary[700]}} variant="contained">
                Shto Grupin
                </Button>
              </Box>
            </form>
          )}
        </Formik>
      </Box>
    );
  };
  
  
  const checkoutSchema = yup.object().shape({
 
    // Description: yup.string().required("Description is required!"),
    customerGroupId: yup.string().required("ID is required!"),
    name: yup.string().required("Name is required!"),
    limit: yup.string().required("Limit is required!"),
    discountPercentage: yup.string().required("Discount Percentage is required!")
  });
  

  const initialValues = {
    customerGroupId: "",
    name: "",
    limit: "",
    discountPercentage: "",
  };
  
  
  export default CustomerGForm;